import { Routes } from '@models/route';
import { lazy } from 'react';

const ListServices = lazy(() =>
  import('@pages/services/list-services').then((p) => ({
    default: p.ListServices
  }))
);

const ViewService = lazy(() =>
  import('@pages/services/view-service').then((p) => ({
    default: p.ViewService
  }))
);

export const ServiceRoutes: Routes = [
  {
    path: '/Services',
    component: ListServices,
    children: [
      {
        path: ':serviceName',
        component: ViewService
      }
    ]
  }
];
